import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './safetyAuthorize.json';

const checkOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/checkOTP'].success.default)));
};

const checkSafetyAuthorize = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/checkSafetyAuthorize'].success.default)));
};

const validateAndSendOTP = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['safetyAuthorizeController/validateAndSendOTP'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('safetyAuthorizeController/checkOTP'), withScenario(checkOTP)),
  rest.post(getApiEndpoint('safetyAuthorizeController/checkSafetyAuthorize'), withScenario(checkSafetyAuthorize)),
  rest.post(getApiEndpoint('safetyAuthorizeController/validateAndSendOTP'), withScenario(validateAndSendOTP)),
];
